import classnames from 'classnames'
import moment from 'moment'

import classes from './BusinessDashboard.module.scss'
import { ReactComponent as DropdownIcon } from '../../../../assets/images/common/icons/select-drop-down-icon-light-navy.svg'
import { Popover } from 'reactstrap'
import Select from '../../../common/form/Select'
import SubmitButton from '../../../common/buttons/SubmitButton'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import PropTypes from 'prop-types'
import { communityCategoriesSelectOptions } from '../../../../reducers/dashboardReducer'

export const DATE_OPTIONS_TO_TEXT_VALUE_FUNCS = {
  '90days': {
    textFunc: () => 'Last 90 days',
    valueFunc: () => ({
      endDate: new Date(),
      startDate: moment()
        .subtract(90, 'days')
        .toDate(),
    }),
  },
  '60days': {
    textFunc: () => 'Last 60 days',
    valueFunc: () => ({
      endDate: new Date(),
      startDate: moment()
        .subtract(60, 'days')
        .toDate(),
    }),
  },
  '30days': {
    textFunc: () => 'Last 30 days',
    valueFunc: () => ({
      endDate: new Date(),
      startDate: moment()
        .subtract(30, 'days')
        .toDate(),
    }),
  },
  '20days': {
    textFunc: () => 'Last 20 days',
    valueFunc: () => ({
      endDate: new Date(),
      startDate: moment()
        .subtract(20, 'days')
        .toDate(),
    }),
  },
  thisYear: {
    textFunc: () => `This year (${moment()
      .year()})`,
    valueFunc: () => ({
      startDate: moment()
        .startOf('year')
        .toDate(),
      endDate: moment()
        .endOf('year')
        .toDate(),
    }),
  },
  lastYear: {
    textFunc: () => `Last year (${moment()
      .subtract(1, 'year')
      .year()})`,
    valueFunc: () =>
      ({
        startDate: moment()
          .subtract(1, 'year')
          .startOf('year')
          .toDate(),
        endDate: moment()
          .subtract(1, 'year')
          .endOf('year')
          .toDate(),
      }),
  },
}

export const DEFAULT_DATE_OPTION = { value: 'thisYear', label: DATE_OPTIONS_TO_TEXT_VALUE_FUNCS.thisYear.textFunc() }

const DATE_OPTIONS = Object.keys(DATE_OPTIONS_TO_TEXT_VALUE_FUNCS).map(key => ({
  value: key,
  label: DATE_OPTIONS_TO_TEXT_VALUE_FUNCS[key].textFunc(),
}))

const FiltersButtonDropdown = ({ dateOption, categoryOption, onSubmitFiltersClick }) => {
  const communityCategoriesOptions = useSelector(communityCategoriesSelectOptions)
  const [editData, setEditData] = useState()
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  const handleOpenFiltersMenuClick = () => {
    if (!isPopoverOpen) {
      setEditData({ dateOption, categoryOption })
    }
    setIsPopoverOpen(value => !value)
  }

  const handleSelectDateOption = (option) => {
    setEditData({ ...editData, dateOption: option })
  }

  const handleSelectCategoryOption = (option) => {
    setEditData({ ...editData, categoryOption: option })
  }

  const handleSubmitFiltersClick = () => {
    onSubmitFiltersClick({ categoryOption: editData?.categoryOption, dateOption: editData?.dateOption })
    setIsPopoverOpen(false)
  }

  const handleClearFiltersClick = () => {
    onSubmitFiltersClick({ dateOption: DEFAULT_DATE_OPTION, categoryOption: null })
    setIsPopoverOpen(false)
  }

  const hasCategoryFilter = categoryOption !== null

  return (
    <>
      {/*TODO: make all ids unique when adding the other widgets*/}
      <button
        id='filtersButton'
        className={classnames('py-2 px-3 d-flex align-items-center', classes.filtersButton)}
        onClick={handleOpenFiltersMenuClick}
      >
        {DATE_OPTIONS_TO_TEXT_VALUE_FUNCS[dateOption.value].textFunc()}
        {hasCategoryFilter && ' + 1 other'}
        <DropdownIcon className={classnames('ml-2', classes.dropdownIcon)} />
      </button>
      <Popover
        target='filtersButton'
        isOpen={isPopoverOpen}
        placement='bottom-end'
        trigger='legacy'
        toggle={handleOpenFiltersMenuClick}
        popperClassName={classnames('px-4 py-3 d-flex flex-column', classes.filtersMenu)}
      >
        <h3 className={classes.title}>Filter Options</h3>
        <label
          htmlFor='categorySelect'
          className={classes.label}
        >
          Program Category
        </label>
        <Select
          id='categorySelect'
          classNames={{ menuList: () => classes.selectMenuList }}
          options={communityCategoriesOptions}
          placeholder='Choose a Program Category'
          value={editData?.categoryOption}
          onChange={handleSelectCategoryOption}
          isClearable
        />
        <label
          htmlFor='dateOptionSelect'
          className={classnames('mt-3', classes.label)}
        >
          Fixed Range
        </label>
        <Select
          id='dateOptionSelect'
          classNames={{ menuList: () => classes.selectMenuList }}
          options={DATE_OPTIONS}
          value={editData?.dateOption}
          onChange={handleSelectDateOption}
        />
        <div className='mt-5 d-flex justify-content-between'>
          <button
            className={classnames(classes.clearButton, classes.buttonWidth)}
            onClick={handleClearFiltersClick}
          >
            Clear
            <i className='ml-2 fa fa-close' />
          </button>
          <SubmitButton
            noTopMargin
            className={classes.buttonWidth}
            buttonMessage='Apply'
            onClick={handleSubmitFiltersClick}
          />
        </div>
      </Popover>
    </>
  )
}

FiltersButtonDropdown.propTypes = {
  dateOption: PropTypes.object.isRequired,
  categoryOption: PropTypes.object,
  onSubmitFiltersClick: PropTypes.func.isRequired,
}

export default FiltersButtonDropdown
